import { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  TextField,
} from "@mui/material";

// project imports
import MainCard from "ui-component/cards/MainCard";
import AdminUserApi from "apis/user.api";

export default function UserEnquiryTable() {
  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");

  const adminUserApi = new AdminUserApi();

  useEffect(() => {
    fetchEnquiries();
  }, []);

  const fetchEnquiries = async () => {
    try {
      setLoading(true);

      const res = await adminUserApi.getUserEnquiry();

      setRows(res?.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch enquiries", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredRows = rows.filter((row) => {
    const searchValue = search.toLowerCase();

    return (
      (row.firstName || "").toLowerCase().includes(searchValue) ||
      (row.lastName || "").toLowerCase().includes(searchValue) ||
      (row.email || "").toLowerCase().includes(searchValue) ||
      (row.phone || "").toString().includes(searchValue)
    );
  });

  return (
    <MainCard title="User Enquiries">
      <Box mb={2}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search by name, email or phone"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </Box>
      {loading ? (
        <Box display="flex" justifyContent="center" py={5}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Message</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredRows.map((row) => (
                <TableRow key={row._id}>
                  <TableCell>
                    <Typography variant="body2">
                      {row.firstName} {row.lastName}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography variant="body2">{row.email}</Typography>
                  </TableCell>

                  <TableCell>{row.phone}</TableCell>

                  <TableCell>
                    <Typography
                      variant="body2"
                      sx={{
                        maxWidth: 300,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {row.message}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Chip
                      size="small"
                      label={new Date(row.createdAt).toLocaleString()}
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              ))}

              {filteredRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No enquiries found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </MainCard>
  );
}